Vue.component('admin-timeslots-index', {

    props: {
        fullscreen: Boolean,
        day: String,
    },

    created() {

    },

    mounted() {
        this.reloadData();

        console.log(this.fullscreen);

        setInterval(() => this.reloadData(false), 30000);

        this.initDatePicker();
    },

    computed: {


    },

    /*
     * Initial state of the component's data.
     */
    data() {
        return {
            timeBlocks: [],
            statuses: [],
            lastUpdate: null,
            onlyFirstTimeBlock: false,
            regions: {},
            updatedLocationStatuses: {},
            loading: false,
        };
    },

    watch: {

    },

    methods: {

        getTimeBlockStatus(timeBlockId, location) {
            if(location.status && location.status.values[timeBlockId]) {
                return location.status.values[timeBlockId];
            } else {
                return this.statuses[0];
            }
        },

        changeStatus(timeBlockId, location) {
            // Disable status changes when in fullscreen.
            if(this.fullscreen) {
                return false;
            }

            if(location.status && location.status.values[timeBlockId]) {

                // Get next color.
                let currentStatusIndex = _.findIndex(this.statuses, {name: location.status.values[timeBlockId].name});
                var nextStatusIndex = currentStatusIndex + 1 >= this.statuses.length ? 0 : currentStatusIndex + 1;

            } else {
                var nextStatusIndex = 1;

                // Create status object if not already exists.
                if(!location.status) {
                    location.status = {location_id: location.id, day: this.day, values: {}};
                }
            }

            // Update current status.
            Vue.set(location.status.values, timeBlockId, this.statuses[nextStatusIndex]);

            // Save to updatedLocationStatuses.
            if(!this.updatedLocationStatuses[location.id]) {
                this.updatedLocationStatuses[location.id] = {};
            }

            this.updatedLocationStatuses[location.id] = location.status.values;

            // Kick reactivity.
            this.regions = Object.assign({}, this.regions);
        },

        reloadData(showLoader = true) {

            // Do not reload if there are update location statuses.
            if(Object.keys(this.updatedLocationStatuses).length > 0) {
                return false;
            }

            // Show loader.
            if(showLoader) {
                this.loading = true;
            }

            console.log(this.day);
            axios.get('/modules/timeslots?day=' + this.day)
                .then((response) => {
                    console.log(response.data);
                    // Update view.
                    this.regions = response.data.regions;
                    this.timeBlocks = response.data.timeBlocks;
                    this.statuses = response.data.statuses;
                    this.lastUpdate = response.data.lastUpdate;
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .finally(() => (this.loading = false))
        },

        save() {
            // Show loader.
            this.loading = true;

            axios.put('/modules/timeslots', {
                day: this.day,
                updatedLocationStatuses: this.updatedLocationStatuses
            })
                .then((response) => {
                    console.log(response);

                    // Update view.
                    this.regions = response.data.regions;
                    this.timeBlocks = response.data.timeBlocks;
                    this.statuses = response.data.statuses;
                    this.lastUpdate = response.data.lastUpdate;

                    // Reset updated location statuses.
                    this.updatedLocationStatuses = {};
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .finally(() => (this.loading = false))
        },

        initDatePicker()
        {
            flatpickr("#datePicker", {
                locale: "nl",
                altInput: true,
                altFormat: "j F Y",
                dateFormat: "d-m-Y",
                onChange: this.onDaterangeUpdated.bind(this)
            });
        },

        onDaterangeUpdated(selectedDates, dateStr, instance)
        {
            // Redirect
           document.location.href = document.location.pathname + '?day=' + dateStr;
        },

    }
});
